export const typesGrouped = {
	all: { name: 'All categories', value: [] },
	assignment: {
		name: 'Assignments',
		value: ['waCreated', 'waStatusUpdated', 'waTimeUpdated', 'waActualCreated', 'waBreakdown'],
	},
	info: {
		name: 'Crew member profile',
		value: [
			'crewMemberInfoUpdated',
			'crewMemberLocationChangeCreated',
			'crewMemberLocationChangeUpdated',
			'crewMemberLocationChangeDeleted',
			'crewMemberHomeBaseCreated',
			'crewMemberHomeBaseUpdated',
			'crewMemberHomeBaseDeleted',
			'crewMemberEmploymentCreated',
			'crewMemberEmploymentUpdated',
			'crewMemberEmploymentDeleted',
		],
	},
	base: {
		name: 'Home base',
		value: ['crewMemberHomeBaseCreated', 'crewMemberHomeBaseUpdated', 'crewMemberHomeBaseDeleted'],
	},
	absence: {
		name: 'Absences',
		value: ['crewMemberAbsenceCreated', 'crewMemberAbsenceUpdated', 'crewMemberAbsenceDeleted'],
	},
	holdDown: {
		name: 'Hold-downs',
		value: ['crewMemberHoldDownCreated', 'crewMemberHoldDownUpdated', 'crewMemberHoldDownDeleted'],
	},
	breakdown: {
		name: 'Breakdowns',
		value: ['waBreakdown'],
	},
};

export const typeTags = {
	assignment: 'Work assignment',
	info: 'Crew member profile',
	base: 'Home base',
	absence: 'Absence',
	holdDown: 'Hold-downs',
	breakdown: 'Breakdown',
};
